import React from "react";

export const getSyncsSteps = () => [
  {
    target: () => document.querySelector('[data-tour-id="sync-tab"]'),
    title: "Sincronizações",
    description: "Integrações ERP que alimentam seus relatórios na plataforma.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        const el = document.querySelector('[data-tour-id="sync-tab"]');
        if (el) el.click();
      },
    },
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-stats"]'),
    title: "Visualizações",
    description: "Total, Ativas e Com Falha — visão do estado das integrações.",
  },
  {
    target: () => document.querySelector('[data-tour-id="syncs-table"]'),
    title: "Tabela de Sincronizações",
    description: "Visualize integrações, status, última execução e ações.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        try {
          window.scrollTo({ top: 0 });
        } catch {
        } finally {
          setTimeout(() => {}, 100);
        }
      },
    },
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-search"]'),
    title: "Filtros",
    description:
      "Busca, Tipo e Status — filtre integrações conforme necessidade.",
  },
  {
    target: () => document.querySelector('[data-tour-id="create-sync-btn"]'),
    title: "Criar nova sincronização",
    description: "Abra o formulário para configurar uma nova integração.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
          const el = window.dispatchEvent(new Event("tour-open-create-sync-modal"));
          if (el) el.click();
          setTimeout(() => window.dispatchEvent(new Event("resize")), 120);
      },
    },
  },
  {
    target: () => {
      return document.querySelector('[data-tour-id="sync-project-select"]');
    },
    placement: "top",
    title: "Selecionar Projeto",
    description: "Escolha o projeto da sincronização.",
    prevButtonProps: {
      children: "Anterior",
      onClick: () =>
        window.dispatchEvent(new Event("tour-close-create-sync-modal")),
    },
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-erp-select"]'),
    title: "Selecionar ERP",
    description: "Defina qual ERP será integração",
    description: "Escolha qual ERP será integrado",
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-type-select"]'),
    title: "Selecionar tipo de sincronização",
    description: "Defina qual o tipo de sincronização.",
    description: "Escolha se será uma sincronização padrão ou consolidado.",
    nextButtonProps: {
      children: "Próximo",
      onClick: () => {
        window.dispatchEvent(new Event("tour-auto-select-first-erp"));
      },
    },
  },
  {
    target: () => document.querySelector('[data-tour-iplacement: "top",ls"]'),
    title: "Credenciais/Autorização",
    description: "Preencha credenciais ou autorize via OAuth.",
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-save-btn"]'),
    title: "Finalizar",
    description: "Clique para criar a sincronização e fechar a modal.",
    nextButtonProps: {
      children: "Concluir",
      onClick: () =>
        window.dispatchEvent(new Event("tour-close-create-sync-modal")),
    },
  },
];
